module.exports = __webpack_public_path__ + "static/media/proj5.6e455b67.jpg";